'use client';

export { default } from './BottomNavigationAction';
export { default as bottomNavigationActionClasses } from './bottomNavigationActionClasses';
export * from './bottomNavigationActionClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/BottomNavigationAction/index.js
// module id = 901
// module chunks = 25